import React from "react";
import logo from "../image/banner.svg";
import "../css/AboutMe.scss";

const AboutMe = () => {
  return (
    // <div className={styles.test}>test</div>
    <div className="AboutMe">
      <img src={logo} className="AboutMe__img" alt="" />
      <div className="AboutMe__info">
        <div className="info">
          <h1 className="info__name">Amorntep Yamkasorn</h1>
          <h2 className="info__title">Frontend Developer</h2>
          <p className="info__date">28 December 2022</p>
          <p className="info__des1">
            Hello! My name is Amorntep Yamkasorn and I am a frontend developer
            with over a year of experience as a freelancer. My expertise lies in
            using HTML, JavaScript, TypeScript, CSS, and SCSS to create visually
            appealing and responsive web applications. I am proficient in using
            React to build dynamic and interactive user interfaces, and I have
            experience working with Tailwind CSS to style my projects.
          </p>
          <p className="info__des2">
            In addition to my frontend skills, I also have experience with
            NodeJS, Express, Python and Django to build robust backends and
            RESTful APIs. I am also familiar with the Google Cloud Platform and
            have experience using Firebase to deploy and host my projects.
          </p>
          <p>
            Lastly, I have experience working with Wordpress, which has allowed
            me to create and customize websites for clients. I am always looking
            for new challenges and opportunities to expand my skillset, and I am
            excited to work with you on your next project.
          </p>
          <img src={logo} className="info__img" alt="" />

        </div>
      </div>
    </div>
  );
};

export default AboutMe;
